import { defineRouting } from 'next-intl/routing';
import { createNavigation } from 'next-intl/navigation';
import { defaultLocale, locales, localePrefix } from './locales';

export const routing = defineRouting({
  locales: [...locales],
  defaultLocale,
  localePrefix,
  localeCookie: false,
  localeDetection: false,
});

export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
